module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Title_Page"
  }, [_c('h2', {
    staticClass: "chaptitle2"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('a', {
    attrs: {
      "href": "#/006_Contents#ch12",
      "id": "rch12"
    }
  }, [_c('b', [_vm._v("Land of the Rising Fun")])])]), _vm._v(" "), _c('p', {
    staticClass: "sub1"
  }, [_vm._v("Japanese popular culture has made two major contributions to the rest of the world: video games and really weird stuff. Here’s where the two meet—weird video games from Japan.")]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/img_p42-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('b', [_c('i', [_vm._v("I’M SORRY")]), _vm._v(" "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("(1985)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("Former Japanese Prime Minister Kakuei Tanaka serves as the main character in this bizarre game, which satirizes the politician and his involvement in various bribery scandals in the early 1980s. Players control Tanaka as he makes his way through a series of maze-like levels while gobbling up gold bars, kind of like in "), _c('i', [_vm._v("Pac-Man")]), _vm._v(". But unlike "), _c('i', [_vm._v("Pac-Man")]), _vm._v(", whose enemies are a group of multicolored ghosts, "), _c('i', [_vm._v("I’m Sorry’s")]), _vm._v(" protagonist faces an onslaught from a group of celebrity enemies, including Michael Jackson, Carl Lewis, Madonna, and Japanese sumo wrestler Shohei Baba. If one of Tanaka’s pursuers manages to capture him, they strip him down to a diaper and whip him as he begs for mercy. Bonus: The title, "), _c('i', [_vm._v("I’m Sorry")]), _vm._v(", is a play on the Japanese word "), _c('i', [_vm._v("sori")]), _vm._v(", which means “prime minister.”")])]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/img_p42-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('b', [_c('i', [_vm._v("TOYLETS")]), _vm._v(" "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("(2010)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("This one consists of an LCD screen placed above a urinal that contains pressure sensors capable of turning the player’s “stream” into a game controller. The four "), _c('i', [_vm._v("Toylets")]), _vm._v(" games, from simple to bizarre:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_c('span', {
    staticClass: "bulls"
  }, [_vm._v("•")]), _vm._v(" "), _c('i', [_vm._v("“Mannekin Pis”")]), _vm._v(" measures how hard the player can pee.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_c('span', {
    staticClass: "bulls"
  }, [_vm._v("•")]), _vm._v(" "), _c('i', [_vm._v("“Graffiti Eraser”")]), _vm._v(" washes graffiti off walls.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_c('span', {
    staticClass: "bulls"
  }, [_vm._v("•")]), _vm._v(" "), _c('i', [_vm._v("“The Northern Wind, The Sun and Me”")]), _vm._v(": The player must provide enough “force” to make a video gust of wind blow up a woman’s skirt. (The harder you pee, the harder the wind blows.)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_c('span', {
    staticClass: "bulls"
  }, [_vm._v("•")]), _vm._v(" "), _c('i', [_vm._v("“Battle! Milk From Nose”")]), _vm._v(": A test of “strength” against the previous player, in which the player’s stream is translated into milk spraying out of his nose. If your stream is stronger, your milk stream knocks your opponent out of the ring.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/img_p43-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('b', [_c('i', [_vm._v("THE TABLECLOTH HOUR")]), _vm._v(" "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("(2010)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("This game gives players the opportunity to do what usually only magicians can pull off—yanking a tablecloth out from underneath an elaborate place setting, leaving the dishes and silverware intact and in place. The screen shows a red sheet loaded with cute, anthropomorphized dishes and silverware. The player must then press a button at just the right moment to pull the tablecloth in order for the dishes to remain perfectly still (You win!) or fly off the table (Game Over). Believe it or not, "), _c('i', [_vm._v("The Tablecloth Hour")]), _vm._v(" is actually the second in a series of games about table settings. "), _c('i', [_vm._v("Ultra Low Dining Table")]), _vm._v(" has a completely opposite objective: The more objects that fall off the table, the more points the player scores.")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/img_p43-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('b', [_c('i', [_vm._v("SUB MARINE CATCHER")]), _vm._v(" "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("(1994)")])])])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("For decades, American arcades and pizza parlors have had “claw games,” where the player controls a claw in order to grab and win a stuffed animal or a toy. Japanese arcades have a variant called "), _c('i', [_vm._v("Sub Marine Catcher")]), _vm._v(". Instead of snatching a Hello Kitty doll or a miniature teddy bear, players can fish a live lobster out of a tank. Should they manage to snag one of the crustaceans, lucky winners are presented with a bag of water by an arcade clerk so they can take their prize catch home.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('b', [_c('i', [_vm._v("BOONG-GA, BOONG-GA")]), _vm._v(" "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("(2001)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("In the U.S., bullies employ the “wedgie” to terrorize their victims. In Japan, they have kancho, a less cruel, slightly less intrusive bit of mischief in which the prankster pokes someone in the butt (crack) with two fingers. "), _c('i', [_vm._v("Boong-Ga, Boong-Ga")]), _vm._v(" is a video-game version of kancho. Players select from a list of eight characters to “punish.” Among them: “Ex-girlfriend,” “Ex-boyfriend,” “Mother-in-Law,” “Gold Digger,” and “Gangster.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("Bonus: Game play is interactive—players poke a denim-covered fake butt, which is attached to the front of the game’s cabinet.")])]), _vm._v(" "), _c('p', {
    staticClass: "centers"
  }, [_c('b', [_vm._v("ZAGAZIG IS A CITY IN EGYPT; WAGGA WAGGA IS A CITY IN AUSTRALIA.")])])])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c7820f3c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/019_Chapter12.vue
// module id = 114
// module chunks = 0